import { redirectURLDefault } from "@lidojs/design-editor";

export const addAHeading = {
  rootId: 'f2d33316-8857-4496-a0c7-3dcc9c4ff981',
  layers: {
    'f2d33316-8857-4496-a0c7-3dcc9c4ff981': {
      type: { resolvedName: 'TextLayer' },
      props: {
        text: '<p style="text-align: center;font-family: Roboto;font-size: 68px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><strong><span style="color: rgb(0, 0, 0);">Add a heading</span></strong></p>',
        position: { x: 525.12102340009, y: 261.582179409994 },
        boxSize: {
          width: 536.3009995574356,
          height: 95,
          x: 523.1390728476821,
          y: 259.9867549668875,
        },
        scale: 1,
        rotate: 0,
        fonts: [
          {
            name: 'Roboto',
            fonts: [
              {
                style: 'Bold',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Bold_Italic',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Bold',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Italic',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
            ],
          },
        ],
        colors: ['rgb(0, 0, 0)'],
        fontSizes: [68],
        hyperlink: {
          hasHyperlink: false,
          typeLink: "a-href",
          linkRedirect: redirectURLDefault
        }
      },
      locked: false,
      child: [],
      parent: 'ROOT',
    },
  },
};

export const addASubheading = {
  rootId: '9cc89a8c-49d5-4f90-9964-f65bbe90db92',
  layers: {
    '9cc89a8c-49d5-4f90-9964-f65bbe90db92': {
      type: { resolvedName: 'TextLayer' },
      props: {
        text: '<p style="text-align: center;font-family: Roboto;font-size: 38px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><strong><span style="color: rgb(0, 0, 0);">Add a subheading</span></strong></p>',
        position: { x: 519.12102340009, y: 365.582179409994 },
        boxSize: {
          width: 536.3009995574356,
          height: 53,
          x: 523.1390728476821,
          y: 259.9867549668875,
        },
        scale: 1,
        rotate: 0,
        fonts: [
          {
            name: 'Roboto',
            fonts: [
              {
                style: 'Bold',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Bold_Italic',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Bold',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Italic',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
            ],
          },
        ],
        colors: ['rgb(0, 0, 0)'],
        fontSizes: [38],
        hyperlink: {
          hasHyperlink: false,
          typeLink: "a-href",
          linkRedirect: redirectURLDefault
        }
      },
      locked: false,
      child: [],
      parent: 'ROOT',
    },
  },
};

export const addABodyText = {
  rootId: '3cace409-216f-4e0e-9449-9248901c8c94',
  layers: {
    '3cace409-216f-4e0e-9449-9248901c8c94': {
      type: { resolvedName: 'TextLayer' },
      props: {
        text: '<p style="text-align: center;font-family: Roboto;font-size: 26px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><span style="color: rgb(0, 0, 0);">Add a little bit of body text</span></p>',
        position: { x: 508.99988653474736, y: 434.903672486454 },
        boxSize: {
          width: 536.3009995574356,
          height: 36,
          x: 523.1390728476821,
          y: 259.9867549668875,
        },
        scale: 1,
        rotate: 0,
        fonts: [
          {
            name: 'Roboto',
            fonts: [
              {
                style: 'Bold',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Bold_Italic',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Bold',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                style: 'Italic',
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
              {
                urls: [
                  'https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
                ],
              },
            ],
          },
        ],
        colors: ['rgb(0, 0, 0)'],
        fontSizes: [26],
        hyperlink: {
          hasHyperlink: false,
          typeLink: "a-href",
          linkRedirect: redirectURLDefault
        }
      },
      locked: false,
      child: [],
      parent: 'ROOT',
    },
  },
};
